import { render, staticRenderFns } from "./ChainedAddress.vue?vue&type=template&id=5a402128&scoped=true&"
import script from "./ChainedAddress.vue?vue&type=script&lang=js&"
export * from "./ChainedAddress.vue?vue&type=script&lang=js&"
import style0 from "./ChainedAddress.vue?vue&type=style&index=0&id=5a402128&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a402128",
  null
  
)

export default component.exports